import querystring from "querystring";
import FilterList from '../../constants/plugins/FilterList'

const compareText = (a, b) => {
	if (a < b) {
		return -1
	} else if (a === b) {
		return 0
	} else {
		return 1
	}
}

const comparePlugin = (a, b) => {
    if ((a.active === b.active) && (a.recommended === b.recommended)){
        return compareText(a.title, b.title)
	}else if (a.active && b.active) {
    	return compareText(a.title, b.title)
    } else {

        if (a.active) {
            return (b.recommended) ? 1 : -1
        } else {
            return (a.recommended) ? -1 : 1
        }
    }
}

export const makeFilteredList = (list, searchKeyword, filter) => {

	let callback = (filter == "pc") ? (item) => item.pc :
										(filter == "mobile") ? (item) => item.mobile :
											(item) => item.category.filter(category => !filter || category === filter).length > 0;

    return list.filter(callback).filter(item =>
        !searchKeyword
        || item.title.toLowerCase().indexOf(searchKeyword.toLowerCase()) >= 0
        || item.name.toLowerCase().indexOf(searchKeyword.toLowerCase()) >= 0
        || item.description.toLowerCase().indexOf(searchKeyword.toLowerCase()) >= 0
        || item.author.toLowerCase().indexOf(searchKeyword.toLowerCase()) >= 0
    ).sort(comparePlugin)
}


export const makeFilter = (pathname) => {
	const path = pathname.split('/plugins/')
	return path[1]? path[1] : ''
}

export const makeSearchKeyword = (search) => {
	if (!search || search.length === 0) {
		return ''
	}

	if (search[0] === '?') {
		search = search.slice(1)
	}

	const params = querystring.parse(search)
	return params.q? params.q : '';
}

export const makeFilterLabel = (filter) => {
	let found = FilterList.find(item => item.category === filter)
	return found? found.label : ''
}
